module.exports = __webpack_public_path__ + "static/img/22-3.8220225.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/22-3.jpg
// module id = Ppr4
// module chunks = 0